/**
 * add accordion functionality for menu items to .s-footer selector
 */
import jQuery from 'jquery'

export default class FeaturesSummary {
  constructor(element) {
    if (!element) {
      return false
    }

    this.$element = jQuery(element)

    jQuery(window).on('scroll', () => {
      this._checkStickyBar()
    })

    jQuery(window).on('resize', () => {
      this._checkStickyBar()
    })
  }

  _checkStickyBar() {
    if (
      jQuery(window).scrollTop() >
      jQuery('.s-features-summary__sticky', this.$element).outerHeight()
    ) {
      jQuery('.s-features-summary__sticky', this.$element).addClass('sticky')

      // new design
      if (jQuery('.s-header').length) {
        jQuery('.s-features-summary__sticky', this.$element).addClass(
          'sticky extra-sticky'
        )
      }
    } else {
      jQuery('.s-features-summary__sticky', this.$element).removeClass(
        'sticky extra-sticky'
      )
    }
  }
}
